import { render } from "./refund_record.vue?vue&type=template&id=1b577e8d&scoped=true"
import script from "./refund_record.vue?vue&type=script&lang=js"
export * from "./refund_record.vue?vue&type=script&lang=js"

import "./refund_record.vue?vue&type=style&index=0&id=1b577e8d&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b577e8d"]])

export default __exports__